window.app = window.app || {};

window.app.trainers = {
  el: {
    sectionHeader: document.querySelector('.mt-trainers__heading'),
    carousel: document.querySelector('.mt-trainers__carousel .swiper'),
    trainerCards: document.querySelectorAll('.mt-trainer')
  },

  init: function() {
    const _this = this;

    // Slider
    if (_this.el.carousel) {
      _this.slider = new Swiper(_this.el.carousel, {
        slidesPerView: 1,
        spaceBetween: 16,
        centeredSlides: true,
        loop: (_this.el.carousel.dataset.loop === 'true'),
        speed: 600,
        preventClicks: false,
        preventClicksPropagation: false,
        roundLengths: true,
        allowTouchMove: true,
        navigation: {
          nextEl: '.mt-trainers__carousel-nav--next',
          prevEl: '.mt-trainers__carousel-nav--prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          600: {
            slidesPerView: 2,
            spaceBetween: 18,
            centeredSlides: false
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 18,
            centeredSlides: false
          },
          1180: {
            slidesPerView: 4,
            spaceBetween: 18,
            centeredSlides: false
          },
          1500: {
            slidesPerView: 5,
            spaceBetween: 18,
            centeredSlides: false
          }
        }
      });
  
      if (_this.el.carousel.dataset.loop === 'true') {
        _this.slider.slidePrev(0);
        _this.slider.slideNext(0);
      }
    }

    // Trainers
    const updateTrainersCards = () => {
      _this.el.trainerCards.forEach(card => {
        const visibleElements = card.querySelectorAll('.mt-trainer__title, .mt-trainer__subtitle');
        let offset = (window.innerWidth >= 992 ) ? 38 : 34;

        visibleElements.forEach(el => {
          offset += el.offsetHeight;
        });

        card.style.setProperty('--content-offset', `${offset}px`);
      });
    };
    _this.el.trainerCards.forEach(card => {
      const trainer = card.querySelector('.mt-trainer__title');

      card.addEventListener('click', e => {
        if (e.target.tagName === 'A' || window.innerWidth >= 768) return;

        e.preventDefault();
        card.classList.toggle('active');
        if (card.classList.contains('active')) {
          _this.el.trainerCards.forEach(c => c !== card && (c.classList.remove('active')));
        }
      });

      // Additional DL event
      card.addEventListener('mouseenter', () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'hover_click',
          link_text: trainer.innerText,
          location: _this.el.sectionHeader.innerText
        });
      }, { once: true });
    });

    updateTrainersCards();
    window.addEventListener('resize', () => {
      updateTrainersCards();
      (window.innerWidth >= 768) && _this.el.trainerCards.forEach(c => c.classList.remove('active'));
    });
  }
}
window.app.trainers.init();